var LMClick = function LMClick(type) {
  // eslint-disable-next-line class-methods-use-this
  return function (target, propertyKey, descriptor) {
    var method = descriptor.value;
    descriptor.value = function () {
      var _state = true;
      var obj = {
        preventDefault: function preventDefault() {
          _state = false;
        },
        state: function state() {
          return _state;
        },
        type: type
      };
      this.$lmBus && this.$lmBus.$emit('lmClick', obj);
      if (_state) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        method.apply(this, args);
      }
    };
    return descriptor;
  };
};
export { LMClick };